import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import i18n from 'i18next';

import Button from '../../buttons/components/button';
import Typo from '../../content/components/typo';
import Loading from './loading';

import styles from '../styles/uikitLoadersProcessStatusBar.module.scss';

const ProcessStatusBar = ({
  className = '',
  onCancelClick = () => {},
  text = i18n.t('processing', 'Processing'),
}) => (
  <div className={classnames(styles.element, className)}>
    <div className={styles.details}>
      <div className={styles.loadingWrapper}>
        <Loading className={styles.loading} size={18} />
      </div>
      <Typo element="span" variant="s02" weight="medium">
        {text}
      </Typo>
    </div>
    <Button
      className={styles.cancelButton}
      onClick={onCancelClick}
      size="small"
      text={i18n.t('cancel', 'Cancel')}
      variant="link"
    />
  </div>
);

ProcessStatusBar.propTypes = {
  className: PropTypes.string,
  onCancelClick: PropTypes.func,
  text: PropTypes.string,
};

export { ProcessStatusBar as ProcessStatusBarStorybook };
export default memo(ProcessStatusBar);
